import React from 'react'

const content = {
  description:
    'DISCLAIMER: This information is provided for general informational purposes only, and publication does not constitute an endorsement. Toast does not warrant the accuracy or completeness of any information, text, graphics, links, or other items contained within this content. Toast does not guarantee you will achieve any specific results if you follow any advice herein. It may be advisable for you to consult with a professional such as a lawyer, accountant, or business advisor for advice specific to your situation.'
}

const Disclaimer = () => {
  return (
    <p className='otl-disclaimer mt-8 font-serif leading-relaxed text-lg'>
      <em>{content.description}</em>
    </p>
  )
}

export default Disclaimer
